import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { MICROSOFT_WEATHER_GDD } from '../constants/featureFlags';
import { FeatureFlagKey } from '../types';

const getFeatureStore = (state: AppState) => state.feature;
const getConfig = (state: AppState) => state.feature.userConfigFeatures;
const getFeatureFlagKey = (_state: AppState, { key }: { key: FeatureFlagKey }) => key;

export const featureFlagsAreFetching = createSelector([getFeatureStore], ({ isFetching }) => isFetching);

export const getFeatureValue = createSelector([
  getConfig,
  getFeatureFlagKey
], (config, key) => Boolean(config[key]?.value));

export const getMicrosoftGDDSelector = createSelector(
  [getConfig],
  (config) => Boolean(config[MICROSOFT_WEATHER_GDD]?.value)
)

export const getPlantingArdDataFeatureSelector = createSelector(
  [getConfig],
  (config) => Boolean(config[FeatureFlagKey.WEB_PLANTING_ARD_DATA]?.value)
)

export const getHarvestArdDataFeatureSelector = createSelector(
  [getConfig],
  (config) => Boolean(config[FeatureFlagKey.WEB_HARVEST_ARD_DATA]?.value))